import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
const handleSwiper = () => {
  const swiper = new Swiper('.swiper-container', {
    speed: 400,
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
      750: {
        slidesPerView: 1.2,
      },
      1024: {
        slidesPerView: 2.3,
      },
      1518: {
        slidesPerView: 'auto',
      },
    },
  });
  const swiper2 = new Swiper('.swiper-container2', {
    modules: [Navigation, Autoplay, Pagination],
    // autoplay: {
    //   delay: 3000,
    // },
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 40,
    dynamicMainBullets: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
  });

  const offerContactSwiper = new Swiper('.key-contacts-swiper', {
    speed: 400,
    slidesPerView: 1.5,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },

      992: {
        slidesPerView: 2.5,
        spaceBetween: 37,
      },

      1200: {
        slidesPerView: 3,
        spaceBetween: 37,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next--contacts',
      prevEl: '.swiper-button-prev--contacts',
    },
  });

  if (window.innerWidth >= 768) {
    const contactSwiper = new Swiper('.contact-key-contacts-swiper', {
      speed: 400,
      slidesPerView: 1.1,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },

        992: {
          slidesPerView: 1.5,
          spaceBetween: 37,
        },

        1200: {
          slidesPerView: 2,
          spaceBetween: 36,
        },

        1538: {
          slidesPerView: 2.7,
          spaceBetween: 36,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next--contacts',
        prevEl: '.swiper-button-prev--contacts',
      },
    });
  }

  const relatedNewsSwiper = new Swiper('.related-news-swiper', {
    speed: 400,
    slidesPerView: 1.3,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 1.4,
        spaceBetween: 18,
      },

      992: {
        slidesPerView: 1.5,
        spaceBetween: 18,
      },

      1200: {
        slidesPerView: 2,
        spaceBetween: 18,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next--news',
      prevEl: '.swiper-button-prev--news',
    },
  });
  const teamSwiper = new Swiper('.swiper-team', {
    speed: 400,
    slidesPerView: 'auto',
  });
};

export default handleSwiper;
